import cyclingImg from "../assets/cyclingImg.png";
import runningImg from "../assets/runningImg.png";

export const sportsOptions = [
    {
      name: "cycling",
      img: cyclingImg,
    },
    
    {
      name: "running",
      img: runningImg,
    },
];